// extracted by mini-css-extract-plugin
module.exports = {"main":"LuckyBirthday_main__2iJ2T","main-form":"LuckyBirthday_main-form__2fnTi","ilstr":"LuckyBirthday_ilstr__2H_xe","hover":"LuckyBirthday_hover__OjBOk"};